import {scriptTemplate} from "./scriptTemplate";
function generateNOfNScript(addressesList) {
    const signersList = addressesList.map((address) => "PK(\"" + address + "\")")
    const signers = signersList.join(" && ")
    return scriptTemplate(signers)
}

export {generateNOfNScript}
